__turbopack_context__.v({
  "actions": "RdX_Na_actions",
  "card": "RdX_Na_card",
  "page": "RdX_Na_page",
  "text": "RdX_Na_text",
});
